import { NextSeo, type NextSeoProps } from "next-seo";
import { useTranslation } from "react-i18next";

import { AppConfig } from "@/config/app.config";

type IProps = NextSeoProps & {
  omitSuffix?: boolean;
};

export const AppHead = (props: IProps) => {
  const { t } = useTranslation();

  const titleArray = [];
  if (props.title) {
    titleArray.push(props.title);
  }

  if (!props.omitSuffix) {
    titleArray.push(t("appName"));
  }

  if (AppConfig.isDevServer) {
    titleArray.unshift("DEV");
  }

  const title = titleArray.join(" | ");
  const description = props.description || t("appDescription");

  return (
    <NextSeo
      {...props}
      title={title}
      description={description}
    />
  );
};
